<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tiposUso.content"
      class="elevation-1 mt-5 rounded-card"
      :loading="loading"
      :server-items-length="tiposUso.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum tipo de uso encontrado"
      loading-text="Carregando tipos de uso..."
      :options="optionsList"
    >
      <template v-slot:item.codigo="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.descricao="{ item }">
        {{ item.descricao }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }" v-if="hasRoleCadastroProduto">
        <v-btn icon
               @click="goToEditTipoUso(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    tiposUso: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
    footerOptions: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Código Interno',
          value: 'codigoInterno',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Situação',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleCadastroProduto']),
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditTipoUso(item) {
      this.$router.push({
        name: 'main.tipos-uso.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este tipo de uso?',
        'O tipo de uso será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
